/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationResponse } from './OrganizationResponse';
import {
    OrganizationResponseFromJSON,
    OrganizationResponseFromJSONTyped,
    OrganizationResponseToJSON,
    OrganizationResponseToJSONTyped,
} from './OrganizationResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface OrganizationResponsePagedResult
 */
export interface OrganizationResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof OrganizationResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<OrganizationResponse>}
     * @memberof OrganizationResponsePagedResult
     */
    data: Array<OrganizationResponse> | null;
}

/**
 * Check if a given object implements the OrganizationResponsePagedResult interface.
 */
export function instanceOfOrganizationResponsePagedResult(value: object): value is OrganizationResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function OrganizationResponsePagedResultFromJSON(json: any): OrganizationResponsePagedResult {
    return OrganizationResponsePagedResultFromJSONTyped(json, false);
}

export function OrganizationResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(OrganizationResponseFromJSON)),
    };
}

export function OrganizationResponsePagedResultToJSON(json: any): OrganizationResponsePagedResult {
    return OrganizationResponsePagedResultToJSONTyped(json, false);
}

export function OrganizationResponsePagedResultToJSONTyped(value?: OrganizationResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(OrganizationResponseToJSON)),
    };
}

